import { Pipe, PipeTransform } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import { selectDevicesPermissions } from "src/app/store/selectors/devices.selectors";
import { selectIdentityManagementPermissions } from "src/app/store/selectors/identitymanagment.selector";
import { selectLicensesPermissions } from "src/app/store/selectors/licenses.selectors";
import { selectProductionToolingPermissions } from "src/app/store/selectors/production.selector";
import { selectSalesPermissions } from "src/app/store/selectors/sales.selector";
import { OperationEnum } from "src/app/utils/enums/operation.enums";
import { hasValue } from 'src/app/angular-core/utils/functions/common.functions';
import { hasApiPermission } from "src/app/utils/functions/permission.function";
import { AllApiPermissions, ApiPermissions } from "src/app/utils/interfaces/auth.interfaces";
import { IRemoteXPACPortalState } from "src/app/utils/interfaces/store.interfaces";
import { selectAnalyticsPermissions } from "src/app/store/selectors/analytics.selector";
import { selectInventoryManagementPermissions } from "src/app/store/selectors/inventorymanagement.selector";


@UntilDestroy()
@Pipe({
  name: 'hasPermission'
})

export class HasPermissionPipe implements PipeTransform {
  constructor(private store: Store<IRemoteXPACPortalState>) { }

  public transform(authenticationService: string, permission: keyof AllApiPermissions, operation?: OperationEnum): Observable<boolean> {

    switch (authenticationService) {
      case "devices": {
        return this.store.select(selectDevicesPermissions)
          .pipe(
            filter(hasValue),
            map((authInfo: ApiPermissions) => {
              return hasApiPermission(permission, authInfo, operation);
            }),
            untilDestroyed(this)
          );
      }
      case "licenses": {
        return this.store.select(selectLicensesPermissions)
          .pipe(
            filter(hasValue),
            map((authInfo: ApiPermissions) => {
              return hasApiPermission(permission, authInfo, operation);
            }),
            untilDestroyed(this)
          );
      }
      case "sales": {
        return this.store.select(selectSalesPermissions)
          .pipe(
            filter(hasValue),
            map((authInfo: ApiPermissions) => {
              return hasApiPermission(permission, authInfo, operation);
            }),
            untilDestroyed(this)
          );
      }
      case "identityManagement": {
        return this.store.select(selectIdentityManagementPermissions)
          .pipe(
            filter(hasValue),
            map((authInfo: ApiPermissions) => {
              return hasApiPermission(permission, authInfo, operation);
            }),
            untilDestroyed(this)
          );
      }
      case "inventory": {
        return this.store.select(selectInventoryManagementPermissions)
          .pipe(
            filter(hasValue),
            map((authInfo: ApiPermissions) => {
              return hasApiPermission(permission, authInfo, operation);
            }),
            untilDestroyed(this)
          );
      }
      case "production": {
        return this.store.select(selectProductionToolingPermissions)
          .pipe(
            filter(hasValue),
            map((authInfo: ApiPermissions) => {
              return hasApiPermission(permission, authInfo, operation);
            }),
            untilDestroyed(this)
          );
      }
      case "analytics": {
        return this.store.select(selectAnalyticsPermissions)
          .pipe(
            filter(hasValue),
            map((authInfo: ApiPermissions) => {
              return hasApiPermission(permission, authInfo, operation);
            }),
            untilDestroyed(this)
          );
      }
      default: {
        throw new Error(`Invalid authentication service '${authenticationService}'`);
      }
    }
  }

}